/**
 * NgwEditorMailInsert — `IMailEditorInsert` 의 NgwEditor 본 구현 (PR-N5).
 *
 * 5 메서드 모두 `extensions/{timeSlot,availability,sharing,officeNote,messageHistory}.ts` 의
 * NgwExtension 명령으로 위임 — `lifecycle.getHandle().executeCommand(...)` 경유.
 *
 * - `timeSlotSpace(height)` → `executeCommand('insertTimeSlotSpace', { height })`
 * - `addSendAvailability(payload)` → `executeCommand('addSendAvailability', payload)`
 *   (payload.id 가 제공되면 doc 안 동일 id 노드 갱신, 미매칭 시 신규 삽입 fallback)
 * - `addSharingAttachments(payload)` → `executeCommand('addSharingAttachments', payload)`
 * - `insertOfficeNote(payload, isHTML)` → `executeCommand('insertOfficeNote', payload, isHTML)`
 *   (isHTML 분기는 명령 안에서 처리 — PMDOMParser vs text node)
 * - `showMessageHistory()` → `executeCommand('triggerShowMessageHistory')`
 *   (handler.messageHistoryAppended + quotedButton.triggerInsert 결합)
 *
 * init 전 (`lifecycle.getHandle()` 이 null) 호출 시 silent — TinyMCEInsert 의 `editorWindow.*`
 * 위임과 동일한 보호 시맨틱.
 *
 * PR-N4 의 stub (NoOp + 1회 warn) 자리를 본 구현으로 교체 — `console.warn` 발화 0건.
 */

import type { IMailEditorInsert } from '../IMailEditorInsert'
import type { OfficeNoteData, SendAvailabilityPayload, SharingAttachmentsPayload } from '../types'
import type { NgwEditorAdapter } from './NgwEditorAdapter'

export class NgwEditorMailInsert implements IMailEditorInsert {
  private readonly adapter: NgwEditorAdapter

  constructor(adapter: NgwEditorAdapter) {
    this.adapter = adapter
  }

  timeSlotSpace(height: number): void {
    const handle = this.adapter.lifecycle.getHandle()
    if (handle == null) return
    handle.executeCommand('insertTimeSlotSpace', { height })
  }

  addSendAvailability(payload: SendAvailabilityPayload): void {
    const handle = this.adapter.lifecycle.getHandle()
    if (handle == null) return
    handle.executeCommand('addSendAvailability', payload)
  }

  addSharingAttachments(payload: SharingAttachmentsPayload): void {
    const handle = this.adapter.lifecycle.getHandle()
    if (handle == null) return
    handle.executeCommand('addSharingAttachments', payload)
  }

  insertOfficeNote(payload: OfficeNoteData, isHTML: boolean): void {
    const handle = this.adapter.lifecycle.getHandle()
    if (handle == null) return
    handle.executeCommand('insertOfficeNote', payload, isHTML)
  }

  showMessageHistory(): void {
    const handle = this.adapter.lifecycle.getHandle()
    if (handle == null) return
    handle.executeCommand('triggerShowMessageHistory')
  }
}
